import React from "react";
import { newContactPath } from "../../../../../../routes";

import { Box, Link } from "@chakra-ui/react";
import { DrawerListItem } from "./DrawerListItem";

export const DrawerLogoutButton = ({ logout }: { logout: () => void }) => {
  return (
    <>
      <Box as="hr" />
      <Box mt={2} px={5}>
        <DrawerListItem as={Link} href={newContactPath()} target="_blank" rel="noreferrer">
          お問い合わせ
        </DrawerListItem>
        <DrawerListItem as="button" onClick={logout}>
          ログアウト
        </DrawerListItem>
      </Box>
    </>
  );
};
